import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslations } from 'js/hooks/i18n';
import { useRemoveQueryParams } from 'js/hooks/navigate';
import { LAYER } from 'js/components/common/PopupManager';
import { VERIDAS_TOKEN_PARAM } from 'js/components/main/Veridas/constants';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const useFailedVeridasLoginAction = () => {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const translate = useTranslations();
    const removeQueryParams = useRemoveQueryParams();
    const veridasToken = new URLSearchParams(search).get(VERIDAS_TOKEN_PARAM);

    return useCallback((): void => {
        if (veridasToken) {
            removeQueryParams([VERIDAS_TOKEN_PARAM]);

            dispatch(showCommonPopupAction({
                layer: LAYER.DATA_VERIFICATION,
                title: translate('playtech.mobile.system.veridas.QRcode.error.title'),
                content: translate('playtech.mobile.system.veridas.QRcode.error')
            }));
        }
    }, [dispatch, veridasToken, translate, removeQueryParams]);
};
